import moment from 'moment';

const getCurrentDateTime = (date: Date = new Date()): any => {
  return moment(date).format('Do MMM YYYY,   HH:mm');
};

export const dateHandler = { getCurrentDateTime };



// WEBPACK FOOTER //
// ./src/helpers/date/dateHandler.ts